import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class SilverMineBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.SILVER_MINE;
}

export default SilverMineBuildingTileEntity;
